import { useCardTemplates } from '../../../api/cards';
import { withForm } from '../../../form-hook';
import { formProps } from '../../../utils/form-props';
import type { CardsSearch, CardsSearchPatch } from '../cards-url-state';
import type { CsvPreview } from './card-batch';
import { OptionsStep } from './OptionsStep';
import { RecipientsStep } from './RecipientsStep';
import { TemplateStep } from './TemplateStep';
import { cardGenFormOpts, type useCardTemplatePick } from './use-card-batch';

/**
 * The `idle` and `error` phases: the three steps an operator fills in before a
 * batch runs. A deliberate pass-through — it distributes the container's state
 * to the steps and owns nothing itself, which keeps the container's phase
 * routing down to one branch per phase. It subscribes to nothing: each step
 * derives its own slice from its own narrow subscriptions, so a keystroke in
 * one step never re-renders the other two.
 */
export const GeneratorForm = withForm({
  ...cardGenFormOpts,
  props: formProps<{
    template: ReturnType<typeof useCardTemplatePick>;
    /** Parsed CSV preview, null until one is loaded. Held by the container so
     *  it survives a batch run. */
    csv: CsvPreview | null;
    search?: CardsSearch;
    error: string | null;
    onCsvFile: (file: File) => void;
    onSubmit: () => void;
    onSearchPatch?: (patch: CardsSearchPatch) => void;
  }>(),
  render: function GeneratorForm({
    form,
    template,
    csv,
    search,
    error,
    onCsvFile,
    onSubmit,
    onSearchPatch,
  }) {
    const savedTemplates = useCardTemplates();

    return (
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
        className="space-y-4"
      >
        <TemplateStep
          form={form}
          template={template}
          savedTemplates={savedTemplates}
          onSearchPatch={onSearchPatch}
        />

        <RecipientsStep
          form={form}
          template={template}
          csv={csv}
          search={search}
          onCsvFile={onCsvFile}
          onSearchPatch={onSearchPatch}
        />

        <OptionsStep
          form={form}
          template={template}
          csv={csv}
          error={error}
          onSearchPatch={onSearchPatch}
        />
      </form>
    );
  },
});
